import { useEffect } from "react";
import { SortCardStyle } from "./SortFilter.Style";
import { IoSwapVerticalSharp } from "react-icons/io5";

const SortCard = ({
  detailsList,
  title,
  setFilterValue,
  filterValue,
  setSortParams,
  setSortOrder,
  visible,
}) => {

  const handleSortChange = (value) => {
    setFilterValue(value);
  };

  useEffect(() => {
    if (filterValue === "Date (Earliest to Latest)") {
      setSortOrder(0);
      setSortParams(0);
    } else if (filterValue === "Date (Latest to Earliest)") {
      setSortOrder(1);
      setSortParams(0);
    } else if (filterValue === "Sender (A-Z)") {
      setSortOrder(0);
      setSortParams(1);
    } else if (filterValue === "Sender (Z-A)") {
      setSortOrder(1);
      setSortParams(1);
    }
    // eslint-disable-next-line
  }, [filterValue]);
  return (
    <div>
      <div className="container">
        <div className="item-container">
          <span className="title">{filterValue ? filterValue : title}</span>
        </div>
        <div className="icon-style">
          <IoSwapVerticalSharp />
        </div>
      </div>

      {visible ? (
        <div>
          <SortCardStyle>
            {detailsList.map((value, index) => (
              <div
                className="list-item"
                key={index}
                onClick={() => handleSortChange(value)}
              >
                {value}
              </div>
            ))}
          </SortCardStyle>
        </div>
      ) : null}
    </div>
  );
};

export default SortCard;
